import { Component } from '@ecs/Component';

export class Shield implements Component {
  readonly type = 'Shield';

  constructor(
    public current: number,
    public max: number,
    public regenRate: number = 0.5, // Shield per second
    public regenDelay: number = 3000, // Milliseconds before regen starts after damage
    public lastDamageTime: number = 0,
    public isActive: boolean = true
  ) {}

  takeDamage(amount: number): number {
    if (!this.isActive) return amount;

    const absorbed = Math.min(amount, this.current);
    this.current -= absorbed;
    this.lastDamageTime = Date.now();
    
    if (this.current <= 0) {
      this.current = 0;
      this.isActive = false;
    }
    
    // Return remaining damage that wasn't absorbed
    return amount - absorbed;
  }
}